import {
  HttpParams as NgHttpParams,
  HttpHeaders as NgHttpHeaders
} from '@angular/common/http';
import {
  HttpParams as CapHttpParams,
  HttpHeaders as CapHttpHeaders
} from '@capacitor/core';

export const NgToCapHttp = {
  convertHeaders: (
    headers?:
      | NgHttpHeaders
      | {
          [header: string]: string | string[];
        }
  ): CapHttpHeaders | undefined => {
    if (headers instanceof NgHttpHeaders) {
      return headers
        .keys()
        .reduce((obj, key) => (obj[key] = headers.get(key)), {});
    } else if (typeof headers === 'object') {
      return Object.keys(headers).reduce(
        (obj, key) =>
          (obj[key] =
            headers[key] instanceof Array ? headers[key][0] : headers[key]),
        {}
      );
    } else {
      return;
    }
  },
  convertParams: (
    params?:
      | NgHttpParams
      | {
          [header: string]: string | string[];
        }
  ): CapHttpParams | undefined => {
    if (params instanceof NgHttpParams) {
      return params
        .keys()
        .reduce((obj, key) => (obj[key] = params.get(key)), {});
    } else if (typeof params === 'object') {
      return Object.keys(params).reduce(
        (obj, key) =>
          (obj[key] =
            params[key] instanceof Array ? params[key][0] : params[key]),
        {}
      );
    } else {
      return;
    }
  }
};

export const CapToNgHttp = {
  convertHeaders: (headers?: CapHttpHeaders): NgHttpHeaders | undefined => {
    if (!headers) {
      return;
    }

    return new NgHttpHeaders(headers);
  }
};
